const base = '/auth'

const routes = {
  root: base,
  login: `${base}/login`,
  forgot: `${base}/forgot-password`,
  setup: `${base}/setup-password`,
  change: `${base}/change-password`,
  registration: `${base}/registration`,
}

export default routes
